import React from "react";
import ReactDOM from "react-dom";
// Styles
import "./styles/app.scss";
// Components
import App from "./app/App";

ReactDOM.render(<App />, document.getElementById("root"));
